import AlcalaAvatar from '@/shared/assets/images/auth/alcala-avatar.jpg';
import BentAvatar from '@/shared/assets/images/auth/bent-avatar.jpg';
import EloyAvatar from '@/shared/assets/images/auth/eloy-avatar.jpg';
import MarcoAvatar from '@/shared/assets/images/auth/marco-avatar.jpg';
import MarioAvatar from '@/shared/assets/images/auth/mario-avatar.webp';
import NadyaAvatar from '@/shared/assets/images/auth/nadya-avatar.jpg';
import VeronikaAvatar from '@/shared/assets/images/auth/veronica-avatar.jpg';

export const STARS = [1, 2, 3, 4, 5];
export const QUOTES = [
  {
    name: 'Alcala.creativo',
    avatar: AlcalaAvatar,
    role: 'Content Creator, Blogger with 4.6M followers',
    text: "It's incredible! This artificial intelligence translates your voice into any language!",
  },
  {
    name: 'Veronika R',
    avatar: VeronikaAvatar,
    role: 'Mentor, Enterprise',
    text: 'Great tool for translating educational videos!',
  },
  {
    name: 'Nadya S.',
    avatar: NadyaAvatar,
    role: 'Deputy Director',
    text: 'A great way to reach new audiences in other countries',
  },
  {
    name: 'Marco P.',
    avatar: MarcoAvatar,
    role: 'Member of the Board of Directors, ReeR India Pvt. Ltd.',
    text: 'Fantastic tool for enhancing contents and making them available on multiple markets',
  },
  {
    name: 'Eloy José G.',
    avatar: EloyAvatar,
    role: 'Profesor Master Dirección Comercial Marketing Farmacéutico',
    text: 'Perfect to translate huge amount of online trainings',
  },
  {
    name: 'Bent D.',
    avatar: BentAvatar,
    role: 'Board Member',
    text: 'Probably the best AI dubbing software on the market right now',
  },
  {
    name: 'Mario K.',
    avatar: MarioAvatar,
    role: 'Startup ',
    text: 'Best tool for dubbing and translating',
  },
];
